// Mega Menu 3 - Header kaydırma animasyonu
class MegaMenu3Handler {
  constructor() {
    this.init();
  }

  init() {
    const megaMenus = document.querySelectorAll('header-menu.mega-menu');
    
    megaMenus.forEach((menu) => {
      const menuContent = menu.querySelector('.mega-menu__content');
      const headerWrapper = menu.closest('.header')?.querySelector('.header-wrapper');
      
      if (!menuContent || !headerWrapper) return;

      let timeoutId = null;

      // Mouse enter - mega-menu açıldığında
      menu.addEventListener('mouseenter', () => {
        // Eğer bir timeout varsa iptal et
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
        
        // Mega-menu görünür olduğunda yüksekliği hesapla
        // Mega-menu'nun tamamen açılmasını bekle (transition süresi kadar)
        setTimeout(() => {
          this.handleMenuOpen(menuContent, headerWrapper);
        }, 350); // var(--duration-long) genellikle ~300ms, biraz fazla bekleyelim
      });

      // Mouse leave - mega-menu kapandığında
      menu.addEventListener('mouseleave', () => {
        // Header'ı hemen sıfırla - animasyon CSS'te zaten tanımlı
        // Mega-menu kapanma animasyonu ile aynı anda başlamalı
        this.handleMenuClose(headerWrapper);
      });
    });
  }

  handleMenuOpen(menuContent, headerWrapper) {
    // Mega-menu görünür mü kontrol et
    const computedStyle = window.getComputedStyle(menuContent);
    if (computedStyle.visibility === 'hidden' || computedStyle.opacity === '0') {
      // Eğer hala görünür değilse tekrar dene
      setTimeout(() => this.handleMenuOpen(menuContent, headerWrapper), 50);
      return;
    }
    
    // Mega-menu'nün gerçek yüksekliğini hesapla
    // getBoundingClientRect kullanarak daha doğru yükseklik al
    const menuRect = menuContent.getBoundingClientRect();
    const menuHeight = menuRect.height;
    
    if (menuHeight > 0) {
      // Header wrapper'a class ekle
      headerWrapper.classList.add('mega-menu-active');
      
      // CSS variable olarak ayarla
      document.documentElement.style.setProperty('--mega-menu-height', `${menuHeight}px`);
    }
  }

  handleMenuClose(headerWrapper) {
    // Mega-menu kapandığında header'ı sıfırla
    headerWrapper.classList.remove('mega-menu-active');
    document.documentElement.style.setProperty('--mega-menu-height', '0px');
  }
}

// Sayfa yüklendiğinde başlat
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu3Handler();
  });
} else {
  new MegaMenu3Handler();
}

